import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'player-record', 'IconPlayerRecord', [["path",{"d":"M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0","key":"svg-0"}]]);